<template>
  <div>
    <div class="section-hero-about">
      <video autoplay loop muted playsinline width="640" preload="metadata" poster="/frontend/assets/images/og-image.jpg">
        <source src="/frontend/assets/videos/video.mp4" type="video/mp4" />
        Váš prehliadač nepodporuje video tag.
      </video>

      <div class="container">
        <div class="paragraph--normal wide text-uppercase text-color-quinary">
          <span class="notranslate" translate="no">SELECTED</span> CARS
        </div>
        <h1 class="heading--0 text-uppercase text-color-quinary mt-1">
          20 Years
          <span class="fw-light"
            >OF<br />
            selling</span
          >
          High-Class
        </h1>
        <div class="d-lg-none mt-4">
          <a
            href="#"
            class="btn btn--normal btn--icon--100 btn--primary text-uppercase justify-content-center w-100"
          >
            <Icon name="material-symbols:expand-circle-down-rounded" /> More
            about company MORE
          </a>
        </div>
      </div>
    </div>

    <div class="section-small section-about-top bg-color-tertiary">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 padding-right-5-lg mb-lg-0 mb-5">
            <div
              class="paragraph--xlarge wide text-uppercase text-color-quinary mb-4"
            >
              ABOUT
            </div>
            <div class="paragraph--xlarge text-color-senary">
              OUR MISSION IS TO PROVIDE OUR CUSTOMERS WORLDWIDE THE BEST SELECTION OF NEW AND PRE OWNED VEHICLES AVAILABLE IN THE MARKET.
            </div>
          </div>
          <div class="col-lg-4 section-about-top-right">
            <div class="slider-container">
              <div class="custom-pagination-container">
                <span class="paragraph--xlarge text-color-quinary">1</span>
                <div class="custom-pagination"></div>
                <span class="paragraph--xlarge text-color-quinary">{{
                  totalSlides
                }}</span>
              </div>
              <Swiper
                :modules="modules"
                :slides-per-view="1"
                :space-between="10"
                :pagination="{
                  el: '.custom-pagination',
                  type: 'progressbar',
                  clickable: true,
                  progressbarOpposite: false,
                }"
                :autoplay="{
                  delay: 3000,
                  disableOnInteraction: false,
                }"
                class="custom-swiper"
                @swiper="onSwiper"
              >
                <SwiperSlide v-for="image in aboutSliderImages" :key="image.id">
                  <div class="slide-content">
                    <img :src="image.url" :alt="image.alt_text || 'Selected Cars'" />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-mini bg-color-primary about-benefits">
      <div class="container">
        <div class="row text-center">
          <div
            class="col-md-4 col-6 padding-top-10-lg padding-top-5 border-left-mini"
          >
            <div
              class="heading--0 text-uppercase text-color-quinary mb-md-2 mb-0"
            >
              20+
            </div>
            <div class="paragraph--xxlarge text-color-senary">Years</div>
          </div>
          <div
            class="col-md-4 col-6 padding-top-10-lg padding-top-5 border-left-mini"
          >
            <div
              class="heading--0 text-uppercase text-color-quinary mb-md-2 mb-0"
            >
              500+
            </div>
            <div class="paragraph--xxlarge text-color-senary">Clients</div>
          </div>
          <div
            class="col-md-4 col-6 padding-top-10-lg padding-top-5 border-left-mini border-right-mini"
          >
            <div
              class="heading--0 text-uppercase text-color-quinary mb-md-2 mb-0"
            >
              1000+
            </div>
            <div class="paragraph--xxlarge text-color-senary">Sold Cars</div>
          </div>
          <div
            class="col-md-4 col-6 padding-top-10-lg padding-top-5 padding-bottom-10-lg border-left-mini"
          >
            <div
              class="heading--0 text-uppercase text-color-quinary mb-md-2 mb-0"
            >
              16
            </div>
            <div class="paragraph--xxlarge text-color-senary">Countries</div>
          </div>
          <div
            class="col-md-4 col-6 padding-top-10-lg padding-top-5 padding-bottom-10-lg border-left-mini"
          >
            <div
              class="heading--0 text-uppercase text-color-quinary mb-md-2 mb-0"
            >
              92
            </div>
            <div class="paragraph--xxlarge text-color-senary">Partner Dealers</div>
          </div>
          <div
            class="col-md-4 col-6 padding-top-10-lg padding-top-5 padding-bottom-10-lg border-left-mini border-right-mini"
          >
            <div
              class="heading--0 text-uppercase text-color-quinary mb-md-2 mb-0"
            >
              15
            </div>
            <div class="paragraph--xxlarge text-color-senary">Employees</div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-small bg-color-tertiary">
      <div class="container">
        <h2
          class="heading--4 fw-light text-color-quinary text-uppercase border-bottom-quinary padding-bottom-3-lg padding-bottom-2 margin-bottom-5-lg margin-bottom-3"
        >
          OUR TEAM
        </h2>

        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-light" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        
        <div v-else-if="error" class="alert alert-danger">
          {{ error }}
        </div>
        
        <div v-else-if="agents.length === 0" class="text-center py-4">
          <p class="text-color-senary">No team members are currently available.</p>
        </div>
        
        <div v-else class="row align-items-center">
          <div v-for="agent in agents" :key="agent.id" class="col-lg-4 col-md-6 mb-lg-0 mb-5">
            <div class="contact-item">
              <div class="contact-item--img contact-item--img--custom mb-3">
                <img 
                  v-if="agent.primary_image" 
                  :src="agent.primary_image.url" 
                  :alt="agent.name" 
                />
                <img 
                  v-else 
                  src="/frontend/assets/images/person.png" 
                  :alt="agent.name" 
                />
              </div>

              <div class="paragraph--xxxlarge text-color-quinary">
                {{ agent.name }}
              </div>
              <div class="text-color-senary">{{ agent.position }}</div>
              
              <!-- Bio section if available -->
              <div v-if="agent.bio" class="text-color-senary mt-3 mb-4">
                {{ agent.bio }}
              </div>
              
              <div v-if="agent.phone" class="d-flex align-items-center gap-3 mb-3 mt-4">
                <div class="icon-circle">
                  <Icon icon="ic:baseline-local-phone" class="iconify phonis" />
                </div>
                <span class="paragraph--xlarge text-color-quinary">{{ agent.phone }}</span>
              </div>

              <div v-if="agent.email" class="d-flex align-items-center gap-3">
                <div class="icon-circle">
                  <Icon icon="ic:sharp-email" class="iconify phonis" />
                </div>
                <span class="paragraph--xlarge text-color-quinary">{{ agent.email }}</span>
              </div>
              
              <!-- Languages if available 
              <div v-if="agent.languages" class="d-flex align-items-center gap-3 mt-3">
                <div class="icon-circle">
                  <Icon name="mdi:translate" />
                </div>
                <span class="paragraph--large text-color-quinary">{{ agent.languages }}</span>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-small bg-color-primary">
      <div class="container">
        <h2
          class="heading--4 fw-light text-color-quinary text-uppercase border-bottom-quinary padding-bottom-3-lg padding-bottom-2 margin-bottom-5-lg margin-bottom-3"
        >
          PASSION IN DETAILS AND LUXURY SEGMENT
        </h2>
        <MasonryGallery />
      </div>
    </div>

    <div class="section-small bg-color-tertiary">
      <div class="container">
        <h2
          class="heading--4 text-lg-start text-center fw-light text-color-quinary text-uppercase border-bottom-quinary padding-bottom-3-lg padding-bottom-2 margin-bottom-5-lg margin-bottom-3"
        >
          OUR SHOWROOM
        </h2>
      </div>
      <AppShowroom />
    </div>

    <AppMap />
    <AppMarquee />
  </div>
</template>

<script>
import AppMap from '../components/AppMap.vue';
import AppMarquee from '../components/AppMarquee.vue';
import MasonryGallery from '../components/MasonryGallery.vue';
import AppShowroom from '../components/AppShowroom.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Autoplay } from 'swiper/modules';
import { Icon } from '@iconify/vue';
import axios from 'axios';

export default {
  components: {
    AppMap,
    AppMarquee,
    MasonryGallery,
    AppShowroom,
    Swiper,
    SwiperSlide,
    Icon
  },
  data() {
    return {
      totalSlides: 8,
      modules: [Pagination, Autoplay],
      agents: [],
      loading: true,
      error: null,
      soldCarsCount: 0,
      aboutSliderImages: []
    };
  },
  methods: {
    onSwiper(swiper) {
      this.totalSlides = swiper.slides.length;
    },
    async fetchAgents() {
      try {
        this.loading = true;
        this.error = null;
        
        const response = await axios.get('/api/about-agents');
        console.log('About page agents response:', response.data);
        
        if (response.data && response.data.agents) {
          this.agents = response.data.agents;
        } else {
          this.error = 'Failed to load team members data';
        }
      } catch (error) {
        console.error('Error fetching about agents:', error);
        this.error = 'An error occurred while loading team members';
      } finally {
        this.loading = false;
      }
    },
    async fetchGalleryImages() {
      try {
        const response = await axios.get('/api/gallery');
        this.aboutSliderImages = response.data.slice(0, 10);
        this.totalSlides = this.aboutSliderImages.length;
      } catch (error) {
        console.error('Error fetching gallery images:', error);
      }
    },
    async fetchSoldCarsCount() {
      try {
        // Use the same approach as the SoldCars page
        const response = await axios.get('/api/vehicles');
        
        // Check if response.data is an array or if it has a data property
        const vehiclesData = Array.isArray(response.data) ? response.data : 
                           (response.data.data ? response.data.data : [response.data]);
        
        console.log('Vehicles data for sold count:', vehiclesData);
        
        // Filter vehicles with 'sold' status and count them
        const soldVehicles = vehiclesData.filter(vehicle => vehicle.status === 'sold');
        this.soldCarsCount = soldVehicles.length;
        
        console.log('Number of sold vehicles:', this.soldCarsCount);
      } catch (error) {
        console.error('Error fetching sold cars count:', error);
        // Set a default value if API fails
        this.soldCarsCount = 1; // Set to 1 as you mentioned having 1 sold car
      }
    }
  },
  mounted() {
    import('../seo.js').then(({ setPageSeo }) => setPageSeo({
      title: 'About Selected Cars | European Car Exporter | 16 Countries Served',
      description: 'Selected Cars is a trusted European car exporter based in Slovakia. 1000+ vehicles exported to 500+ clients across 16 countries including UAE, Saudi Arabia, Qatar, China and more. 92 partner dealerships across Europe. Professional team of 15 specialists.',
      keywords: 'about selected cars, european car exporter, car export company europe, trusted car dealer international, car exporter slovakia, who is selected cars, european car broker worldwide, luxury car exporter, selected cars reviews, international car dealer europe, car dealer serving middle east, car dealer serving asia, 16 countries car export',
      breadcrumbs: [
        { name: 'Home', url: '/' },
        { name: 'About Us', url: '/about' }
      ]
    }));
    this.fetchAgents();
    this.fetchSoldCarsCount();
    this.fetchGalleryImages();
  }
};
</script>

<style scoped>
.hero-section {
  padding-top: 80px; /* To account for the fixed header */
}

.team-member {
  text-align: center;
}

.team-member img {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
}


</style>
